import { type ComponentProps } from "react";

import { cn } from "../../utils";

export const Root = ({ ref, className, ...props }: ComponentProps<"nav">) => (
  <nav
    ref={ref}
    aria-label="breadcrumb"
    {...props}
    className={cn("flex flex-col items-start gap-1 border-b border-neutral-95 bg-white px-4 py-2.5", className)}
  />
);

Root.displayName = "BreadcrumbRoot";

export default Root;
